import React from "react";
import { ViewDetailsHeading } from "../../../../components/ViewDetailsHeading";
import { NameAndHub } from "../NameAndHub";
import { camelCase } from "../../../../utils";
import { Row, Col } from "antd";

export function ViewCpDetails({ cpDetails, apiResponse, id }) {
  console.log({ cpDetails });
  return (
    <>
      {" "}
      <ViewDetailsHeading
        text={"CP Details"}
        itemkey={0}
        apiResponse={apiResponse}
        id={id}
      />
      <div className="view-basic-details">
        <div className="view-details-header">
          <div className="view-details-header-text">Basic Details</div>
        </div>
        {/* <div className="view-basic-details-contain">
        
        </div> */}
        <Row className="basic-details-view">
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"CP name"} hub={cpDetails.cpName} />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"Zone"} hub={cpDetails?.zone} />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Mini Hub Connected"}
                  hub={cpDetails?.mineHubConnected == true ? "Yes" : "No"}
                />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"CP type"} hub={cpDetails?.cpType} />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Rate card type"}
                  hub={cpDetails?.rateCardType}
                />
              </div>
            </div>
            {cpDetails?.mineHubConnected && (
              <div className="basic-details-container">
                <div>
                  <NameAndHub
                    name={"Mini Hub Name"}
                    hub={camelCase(cpDetails?.mineHubName)}
                  />
                </div>
              </div>
            )}
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Mother hub name "}
                  hub={cpDetails?.motherName}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Billing cycles"}
                  hub={cpDetails?.billingCycle}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
